import { SplashController, SplashIndex } from "../../independent/splashScreen/SplashController";
import { Presentation } from "../../../dev/gameflow/controller/Presentation";
import { RoadRageEngineManager } from "../../reel/RoadRageEngineManager";
import { StateHandler } from "../../../dev/utils/StateHandler";
import { SoundManager } from '../../config/sound/SoundManager';
import { SoundConfig } from '../../config/sound/SoundConfig';
import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { GameData, BaseModel } from '../../server/data/BaseModel';
import { RoadRage } from '../../RoadRage';

class BonusState extends StateHandler {

    public static START:string = "start";
    public static DONE:string = "done";

}

export class FSOutroPresentation extends Presentation {

    protected state:BonusState = new BonusState(BonusState.START);
    protected nextModePreferedSize:number = 3;

    private wasABuy:boolean = false;
    private isBelowStake:boolean = false;
    
    checkForActivation(data: GameData): boolean { 
        return data.lastFSRound && !data.Win.brokeTheBank;    
    }

    setGamedData(data: GameData): void {
        SplashController.instance.setData(SplashIndex.OUTRO,data);
        this.wasABuy = data.raw.wasFeatureBuy;
        this.isBelowStake = data.Win.isWinBelowStake!();
    }

    preStart(): void {
        RoadRageEngineManager.preferedLayoutSize = this.nextModePreferedSize;
        RoadRage.backgroundElements.resetRequest();
    }
    
    createPresentation(skip:Function): void {
        skip(false);
        
        if(RoadRage.counter.timeRemaining){
            this.timeline.to(this,{duration:RoadRage.counter.timeRemaining});
            return;
        }

        SoundManager.fadeOutAmbient(100,0);
        SlotGame.keypadPlugin.hide(1);
        SlotGame.keypadPlugin.setZeroBetSpinCounter(-1);
        RoadRage.backgroundElements.slowDownCloud();

        if(!this.isBelowStake)
            SoundManager.playSoundEffect("fsEnd");

        this.timeline.add(SplashController.instance.play(SplashIndex.OUTRO,true,() => {
            if(this.isBelowStake) return;
            if(this.wasABuy)
                SoundManager.playSoundEffect(SoundConfig.CONTINUE_AFTER_FS_BUY)
            else
                SoundManager.playSoundEffect(SoundConfig.CONTINUE_AFTER_FS)
        }));

        this.PresentationState.setInactive();
    }

    public done(): void {
        
        SoundManager.emptyLoop();
        SoundManager.StartMainMusic(false);
        SoundManager.fadeSound(SoundConfig.MAIN_AMBIANCE,0,1,5000);
        BaseModel.buyFeatureName = "";
        // SlotGame.keypadPlugin.show(0.25);
    }
}